
import AsymmetricEncryptionService from "../services/AsymmetricEncryptionService"

export default {
    name: 'FeatureMixin',
    computed: {
        featureFlags() {
            if (!window._9abc1234_16978980000223) {
                return [];
            }
            
            let decodedData;
            
            // Try new asymmetric decryption first
            try {
                const decrypted = AsymmetricEncryptionService.decryptFromBackend(window._9abc1234_16978980000223);
                decodedData = JSON.parse(decrypted);
            } catch (error) {
                // NO FALLBACK - new encryption must work to avoid exposing APP_KEY
                console.error('Failed to decrypt feature flags:', error);
                return [];
            }
            
            return decodedData || [];
        }
    },
    methods: {
        hasFeature(feature) {
            return this.featureFlags?.includes(feature);
        }
    }
};
